// extracted by mini-css-extract-plugin
module.exports = {"selectorWrapper":"MobileSelector-module--selectorWrapper--1ucHU"};